import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';

import { ELEVATED_ROLES } from '@/lib/constants/auth.constants';
import { OneRosterApiTyped } from '@/lib/http.server';
import { assertUserHasRole } from '@/middlewares/userAuthMiddleware';
import { standardMiddlewares } from '@/middlewares/standardMiddlewares';

import { GetCourseComponentsResponse } from '../api/types';

export const getCourseComponentsDefaultParams = {
  filter: ``,
  sort: 'sortOrder',
  orderBy: 'asc',
  limit: '3000',
  offset: '0',
  search: '',
};

const fetchOnerosterCourseComponents = async (
  onerosterApi: OneRosterApiTyped,
  params: {
    filter?: string;
    sort?: string;
    limit?: string;
    offset?: string;
    orderBy?: string;
    search?: string;
  }
) => {
  const mergedParams = Object.assign(
    {},
    getCourseComponentsDefaultParams,
    params
  );

  const response = await onerosterApi.GET(
    '/ims/oneroster/rostering/v1p2/courses/components',
    {
      params: {
        query: {
          filter: mergedParams.filter,
          sort: mergedParams.sort,
          orderBy: (mergedParams.orderBy ?? 'asc') as 'asc' | 'desc',
          limit: parseInt(mergedParams.limit),
          offset: parseInt(mergedParams.offset),
          search: mergedParams.search ?? '',
        },
      },
    }
  );

  return response.data;
};

export const getCourseComponents = createServerFn({ method: 'POST' })
  .middleware([standardMiddlewares])
  .validator(
    z.object({
      filter: z
        .string()
        .optional()
        .default(getCourseComponentsDefaultParams.filter),
      sort: z
        .string()
        .optional()
        .default(getCourseComponentsDefaultParams.sort),
      limit: z
        .string()
        .optional()
        .default(getCourseComponentsDefaultParams.limit),
      offset: z
        .string()
        .optional()
        .default(getCourseComponentsDefaultParams.offset),
      search: z
        .string()
        .optional()
        .default(getCourseComponentsDefaultParams.search),
    })
  )
  .handler(async ({ context: { cognitoUser, oneRosterApiTyped }, data }) => {
    await assertUserHasRole(cognitoUser, oneRosterApiTyped, ELEVATED_ROLES);
    const response = await fetchOnerosterCourseComponents(
      oneRosterApiTyped,
      data
    );
    return {
      data: response,
      success: true,
      error: null,
    } as unknown as GetCourseComponentsResponse;
  });
